export default "__VITE_ASSET__DxzBKB1t__"